import { andThen, composeWith } from 'ramda';

// composeP was removed from Ramda in 0.28

// Pipelines several asynchronous or synchronous functions, resolving the
// result of each before passing it to the next function

// Note: The first function (i.e. last element in the provided array) MUST return a promise.
//       All others may either be synchronous or asynchronous

// [(* -> Promise[*] | *)] -> (A, B, C, ...) -> *
export const composeP = composeWith(andThen);
